import { gql } from '@apollo/client'

export const GET_COACH_ANALYTICS = gql`
  query CoachAnalytics($timeRange: PGACoachAnalyticsTimeRangeInput) {
    pgaCoachAnalytics(timeRange: $timeRange) {
      # Earnings analytics
      earnings {
        total
        byMonth {
          month
          total
        }
      }
      # Group events analytics
      groupEvents {
        revenue
        byMonth {
          month
          count
        }
        topEarning(limit: 5) {
          groupEvent {
            title
            id
          }
          earnings
          registrationCount
        }
      }
      # Leads analytics
      leads {
        totalCount
        unviewedCount
        convertedCount
        conversionRate
        byMonth {
          month
          count
        }
      }
      # Private lesson analytics
      privateLessonTypes {
        revenue
        totalTypes
        byMonth {
          month
          count
        }
        topBooked(limit: 5) {
          lessonType {
            title
            id
          }
          earnings
          lessonCount
          uniqueStudentCount
        }
      }
    }
  }
`
